<template>
  <section
    class="login-register"
    :style="{
      '--background-landscape': `url(${accessConfig.loginView.bg})`,
      '--background-portrait': `url(${accessConfig.loginView.bgPortrait})`,
      '--bgColor': bgColor,
      '--panelColor': panelColor,
      '--labelColor': labelColor,
      '--boxShadow': boxShadow,
      '--backdropFilter': backdropFilter,
      '--banner-height': bannerHeight + 'px',
    }">
    <LanguageSwitcher
      class="login-register-language-switcher"
      :selected="$store.state.user.language"
      @change="onLanguageChange"
      :showFlag="true"
      :showSelect="true"
      :showFlagInOptions="true"
      v-if="$store.state.template.multilanguagesConfig" />
    <div class="login-content-container">
      <div class="kv-spacer" v-if="accessConfig.loginView.position == 'right'">
        <img :src="accessConfig.loginView.eventImage" class="login-logo" v-if="accessConfig.loginView.eventImage" />
      </div>
      <div class="outside-inside-container">
        <div class="opt-container" v-if="accessConfig.loginView.panelImageOutside">
          <img :src="accessConfig.loginView.loginPanelImage" class="login-logo" v-if="accessConfig.loginView.loginPanelImage && !register" />
          <img
            :src="accessConfig.registerView.registerPanelImage ? accessConfig.registerView.registerPanelImage : accessConfig.loginView.loginPanelImage"
            class="login-logo"
            v-if="(accessConfig.registerView.registerPanelImage || accessConfig.loginView.loginPanelImage) && register" />
        </div>
        <div class="fields-container">
          <div class="opt-container" v-if="!accessConfig.loginView.panelImageOutside">
            <img :src="accessConfig.loginView.loginPanelImage" class="login-logo" v-if="accessConfig.loginView.loginPanelImage && !register" />
            <img
              :src="accessConfig.registerView.registerPanelImage ? accessConfig.registerView.registerPanelImage : accessConfig.loginView.loginPanelImage"
              class="login-logo"
              v-if="(accessConfig.registerView.registerPanelImage || accessConfig.loginView.loginPanelImage) && register" />
          </div>
          <div class="login-form">
            <div class="opt-container"></div>

            <component
              :is="comp"
              :use-password="currentOption.option.passwordUsed"
              :placeholder="accessConfig.loginView.idPlaceholder"
              :password-placeholder="accessConfig.loginView.categorySelector ? currentOption.option.passwordPlaceholder : accessConfig.loginView.passwordPlaceholder"
              :cta="accessConfig.loginView.accessButton"
              :useUsername="accessConfig.loginView.useUsername"
              :useEmail="accessConfig.loginView.useEmail"
              :placeholderUsername="accessConfig.loginView.placeholderUsername"
              :placeholderEmail="accessConfig.loginView.placeholderEmail"
              @logged="onUserLogin"
              @error="onLoginError"
              v-if="!register && !forgotPassword && !changePassword" />
            <a class="login-button" v-if="!accessConfig.accessControl && accessConfig.allowAnonimous" @click.prevent="loginAnonimous"><p v-html="accessConfig.loginView.accessButton"></p></a>

            <FormInputs :accessConfig="accessConfig" :fieldGroups="registerFieldGroups" :autoLogin="accessConfig.registerView.autoLogin" v-if="register && accessConfig.publicSignIn" @goLogin="goLogin" />
            <span class="inactive-register-text" v-if="register && !accessConfig.publicSignIn && accessConfig.registerView.inactiveRegisterHtml" v-html="accessConfig.registerView.inactiveRegisterHtml"></span>

            <ForgotPassword v-if="forgotPassword && !register" @sent="onForgotPassword" @error="onLoginError" :cta="accessConfig.forgetPasswordView.buttonText" />
            <NewPassword
              v-if="changePassword && !register"
              @changed="onNewPassword"
              @error="onLoginError"
              :cta="accessConfig.newPasswordView.buttonText"
              :placeholderConfirm="accessConfig.newPasswordView.confirmPasswordPlaceholder"
              :placeholder="accessConfig.newPasswordView.passwordPlaceholder" />

            <a class="login-button google-login" v-if="accessConfig.accessControl && accessConfig.googleAuth" v-bind:href="'https://backend.blitzar.com.br/api/event/' + $store.state.eventId + '/google/login?web=' + host">
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google G logo" style="height: 24px; vertical-align: middle; margin-right: 8px" />
              Google login
            </a>
            <div class="bottom-instructions">
              <a v-if="accessConfig.accessControl && accessConfig.passwordUsed && !forgotPassword && !register && !changePassword" href="#" @click.prevent="showForgetPassword" class="login-forgot-password" active-class="active">
                <p v-html="accessConfig.loginView.forgetPasswordText"></p>
              </a>
              <a v-if="accessConfig.accessControl && accessConfig.passwordUsed && forgotPassword" href="#" @click.prevent="showLogin" class="login-forgot-password" active-class="active">
                <p v-html="accessConfig.forgetPasswordView.backButtonText"></p>
              </a>
              <div v-if="accessConfig.accessControl && accessConfig.publicSignIn" class="login-signin-first">
                <a class="login-click-here" href="#" @click.prevent="setRegister(true)" v-if="!register"><p v-html="accessConfig.loginView.signInText"></p></a>
                <a class="login-click-here" href="#" @click.prevent="setRegister(false)" v-if="register"><p v-html="accessConfig.registerView.signInText"></p></a>
              </div>
            </div>
            <div class="bottom-out-link-container">
              <a class="bottom-out-link" :href="accessConfig.loginView.outLink" target="_blank" v-html="accessConfig.loginView.outText"></a>
            </div>
            <div v-if="accessConfig.loginView.bottomHtml" v-html="accessConfig.loginView.bottomHtml"></div>
            <!-- TERMS -->
            <div :class="{ 'bottom-terms': !shakeAgree, 'bottom-terms shakeAnimation': shakeAgree }" v-if="accessConfig.loginPageAnonimous && accessConfig.registerView.agreeText">
              <input type="checkbox" style="cursor: pointer" v-model="agree" />
              &nbsp;
              <span class="register-term-text" v-html="accessConfig.registerView.agreeText"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-bottom-banner-container" ref="bannerContainer" v-if="$store.state.template.banners.enableBanners">
      <!-- <span class="login-banner-sponsor-text" v-if="showBanner">patrocínio:</span> -->
      <Banner style="flex-grow: 0" :bannerSlot="'login_bottom_banner'" @enableBanner="showBanner = true" @disableBanner="showBanner = false" :bannerOverwrite="mat" v-for="mat in banners" :key="mat.banner_idt" />
    </div>
    <div class="footer-wrapper">
      <Footer />
    </div>
  </section>
</template>

<script>
import Banner from '@/components/banners/Banner.vue';
import Footer from '@/components/general/Footer.vue';
import FormInputs from '@/components/general/FormInputs.vue';
import ForgotPassword from './login/ForgotPassword.vue';
import NewPassword from './login/NewPassword.vue';
import LanguageSwitcher from '@/components/general/LanguageSwitcher.vue';

import Email from '@/components/home/login/Email.vue';
import CPF from '@/components/home/login/CPF.vue';
import Code from '@/components/home/login/Code.vue';
import Eventbrite from '@/components/home/login/Eventbrite.vue';
import RDStation from '@/components/home/login/RDStation.vue';
import Sympla from '@/components/home/login/Sympla.vue';
import TCS from '@/components/home/login/TCS.vue';
import UNICOCHECK from '@/components/home/login/UNICOCHECK.vue';
import Anonimous from '@/components/home/login/Anonimous.vue';

import redirect from '@/services/redirect';
import api from '@/services/api';

export default {
  name: 'LoginRegister',

  components: {
    LanguageSwitcher,
    Banner,
    Footer,
    FormInputs,
    ForgotPassword,
    NewPassword,
  },

  props: { revalidateUser: Boolean, previousRoute: Object },

  data() {
    return {
      accessConfig: { passwordUsed: false },
      boxShadow: '0px 0px 40px 0 rgba(0, 0, 0, 0.0)',
      backdropFilter: 'none',
      panelColor: '#ffffff',
      bgColor: '#ffffff',
      labelColor: '#000000',
      categoryOptions: [],
      currentOption: { option: '' },
      host: location.protocol + '//' + location.host,
      comp: null,
      register: false,
      registerFieldGroups: null,
      forgotPassword: false,
      changePassword: false,
      shakeAgree: false,
      agree: true,
      banners: [],
      bannerHeight: 110, // default fallback
    };
  },

  methods: {
    showForgetPassword() {
      this.forgotPassword = true;
      this.changePassword = false;
      this.register = false;
    },

    showCreatePassword() {
      this.forgotPassword = false;
      this.changePassword = true;
      this.register = false;
    },

    showLogin() {
      this.forgotPassword = false;
      this.changePassword = false;
      this.register = false;
    },

    onLanguageChange(languageData) {
      // languageData: { code, name }
      if (languageData && languageData.code) {
        this.$store.commit('setUserLanguage', languageData.code);

        // Update accessConfig when multilanguagesConfig is enabled
        if (this.$store.state.template.multilanguagesConfig) {
          this.updateAccessConfigForLanguage(languageData.code);
        }
      }
    },

    updateAccessConfigForLanguage(languageCode) {
      const userLanguage = languageCode ? languageCode.toLowerCase() : 'pt';

      // Update accessConfig with the new language configuration
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];

      // Update visual properties based on new accessConfig
      if (this.accessConfig.loginView.bgColor) {
        this.bgColor = this.accessConfig.loginView.bgColor;
      }
      if (this.accessConfig.loginView.panelColor) {
        this.panelColor = this.accessConfig.loginView.panelColor;
      }
      this.boxShadow = this.accessConfig.loginView.boxShadow ? this.accessConfig.loginView.boxShadow : '0px 0px 40px 0 rgba(0, 0, 0, 0.0)';
      if (this.accessConfig.registerView.labelColor) {
        this.labelColor = this.accessConfig.registerView.labelColor;
      }

      // Update password placeholder if available
      if (this.accessConfig.loginView.passwordPlaceholder) {
        this.passwordPlaceholder = this.accessConfig.loginView.passwordPlaceholder;
      }

      // Update backdrop filter if provided by backend
      this.backdropFilter = this.accessConfig.loginView.backdropFilter ? this.accessConfig.loginView.backdropFilter : this.backdropFilter;

      // Update category options for new language
      this.categoryOptions = this.accessConfig.loginView.categorySelector ? this.accessConfig.loginView.categorySelector.options : [];
      if (!this.accessConfig.loginView.categorySelector) {
        this.currentOption.option = {
          passwordUsed: this.accessConfig.passwordUsed,
          passwordPlaceholder: this.accessConfig.loginView.passwordPlaceholder,
        };
      }

      // Update register field groups with new language configuration
      if (this.accessConfig.registerView.fieldGroups) {
        this.registerFieldGroups = this.accessConfig.registerView.fieldGroups.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
        this.registerFieldGroups.map((group) => {
          group.fields.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
        });

        // Process conditions to lower case
        this.registerFieldGroups.map((group) => {
          group.fields.map((field) => {
            if (field.conditional) {
              field.conditional.map((item) => {
                item.condition = item.condition.map((cond) => {
                  return cond.toLowerCase();
                });
              });
            }
          });
        });
      }

      // Update agree checkbox default value
      this.agree = this.accessConfig.registerView.agreeDefaultValue ? this.accessConfig.registerView.agreeDefaultValue : false;
    },

    onForgotPassword(success) {
      if (success) {
        this.$modal.show('dialog', {
          title: '',
          text: this.accessConfig.forgetPasswordView.successMessage ? this.accessConfig.forgetPasswordView.successMessage : 'Sucesso!',
          buttons: [
            {
              title: 'Ok',
              handler: () => {
                this.$modal.hide('dialog');
                this.forgotPassword = false;
                this.$emit('close');
              },
            },
          ],
        });
      } else {
        this.$modal.show('dialog', {
          title: '',
          text: this.accessConfig.forgetPasswordView.failMessage ? this.accessConfig.forgetPasswordView.failMessage : 'Seu acesso falhou, por favor revise suas informações e tente novamente.',
          buttons: [
            {
              title: 'Ok',
              handler: () => {
                this.$modal.hide('dialog');
              },
            },
          ],
        });
      }
    },

    onNewPassword(success) {
      if (success) {
        this.changePassword = false;
      } else {
        this.$modal.show('dialog', {
          title: '',
          text: this.accessConfig.newPasswordView.failMessage,
          buttons: [
            {
              title: 'Ok',
              handler: () => {
                this.$modal.hide('dialog');
              },
            },
          ],
        });
      }
    },
    loginAnonimous() {
      //console.log('this.accessConfig.firstPage:', this.accessConfig.firstPage);
      //console.log('this.accessConfig.firstPageParams:', this.accessConfig.firstPageParams);
      if (!this.agree) {
        this.shakeAgree = !this.shakeAgree;
      } else
        this.$router.push({
          name: this.accessConfig.firstPage,
          params: this.accessConfig.firstPageParams ?? null,
        });
    },
    onUserLogin(response) {
      this.$store.commit({
        type: 'setUser',
        userData: response.data,
      });

      redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
    },

    onLoginError(reason) {
      let msg;

      if (reason == 'notValidated') {
        msg = this.accessConfig.loginView.notValidatedMessage
          ? this.accessConfig.loginView.notValidatedMessage
          : 'Seu email ainda não foi validado. Um novo email foi disparado para sua conta. Por favor, faça a validação antes de tentar logar novamente.';
      } else if (reason == 'fail') {
        msg = this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações';
      }

      this.$modal.show('dialog', {
        title: '',
        text: msg,
        buttons: [
          {
            title: 'Ok',
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },

    updateBannerHeight() {
      this.$nextTick(() => {
        if (this.$refs.bannerContainer) {
          this.bannerHeight = this.$refs.bannerContainer.offsetHeight || 0;
          this.bannerHeight = this.bannerHeight + 46;
        }
      });
    },

    getApiBannerLogin() {
      let bannerQuery = '?tag=login_bottom_banner';

      api
        .get(`event/${this.$store.state.eventId}/banner${bannerQuery}`)
        .then((response) => {
          this.banners = response.data.filter((org) => org.material.length);

          let tempBanners = [];
          this.banners.map((org) => {
            org.material.map((banner) => tempBanners.push(banner));
          });

          this.banners = [];
          this.banners = tempBanners.sort((a, b) => (a.sponsor_plan > b.sponsor_plan ? 1 : -1));

          this.$emit('disableBanner');

          // Update banner height after banners are loaded
          this.updateBannerHeight();
        })
        .catch((error) => console.error(error));
    },

    setRegister(isRegister) {
      this.register = isRegister;
      this.forgotPassword = false;
      this.changePassword = false;

      if (this.register) {
        this.$store.commit('resetUser');
      }
    },
    goLogin() {
      this.showLogin();
    },
  },

  mounted() {
    // Watch for banner height changes
    this.updateBannerHeight();

    // Set up a resize observer to handle dynamic banner height changes
    if (window.ResizeObserver && this.$refs.bannerContainer) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateBannerHeight();
      });
      this.resizeObserver.observe(this.$refs.bannerContainer);
    }
    //console.log('Salvando no storage');

    localStorage.setItem('loginGoogleRevalidate', JSON.stringify({ revalidateUser: this.revalidateUser, previousRoute: this.previousRoute }));
    //this.$store.state.loginGoogleRevalidate = this.revalidateUser;
    //this.$store.state.loginGooglePrevious = this.previousRoute;
    const loginGoogleRevalidate = JSON.parse(localStorage.getItem('loginGoogleRevalidate'));
    if (loginGoogleRevalidate) {
      //console.log('Salvo no storage', loginGoogleRevalidate);
    }
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    let userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';

    if (this.$store.state.template.multilanguagesConfig) {
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];
      this.accessConfig.loginFirst = true;
    }

    if (this.accessConfig.loginView.bgColor) this.bgColor = this.accessConfig.loginView.bgColor;
    if (this.accessConfig.loginView.panelColor) this.panelColor = this.accessConfig.loginView.panelColor;
    this.boxShadow = this.accessConfig.loginView.boxShadow ? this.accessConfig.loginView.boxShadow : this.boxShadow;
    this.backdropFilter = this.accessConfig.loginView.backdropFilter ? this.accessConfig.loginView.backdropFilter : this.backdropFilter;
    if (this.accessConfig.registerView.labelColor) this.labelColor = this.accessConfig.registerView.labelColor;

    if (this.accessConfig.loginView.passwordPlaceholder) this.passwordPlaceholder = this.accessConfig.loginView.passwordPlaceholder;

    this.categoryOptions = this.accessConfig.loginView.categorySelector ? this.accessConfig.loginView.categorySelector.options : [];
    if (!this.accessConfig.loginView.categorySelector) {
      this.currentOption.option = { passwordUsed: this.accessConfig.passwordUsed, passwordPlaceholder: this.accessConfig.loginView.passwordPlaceholder };
    }

    this.getApiBannerLogin();

    if (this.accessConfig.accessControl) {
      //console.log('this.accessConfig.integration:', this.accessConfig.integration);
      switch (this.accessConfig.integration) {
        case 'cpf':
          this.comp = CPF;
          break;

        case 'code':
          this.comp = Code;
          break;

        case 'anonimous':
          this.comp = Anonimous;
          break;

        case 'eventBrite':
          this.comp = Eventbrite;
          break;

        case 'sympla':
          this.comp = Sympla;
          break;

        case 'rdstation':
          this.comp = RDStation;
          break;

        case 'TCS':
          this.comp = TCS;
          break;

        case 'UNICOCHECK':
          //console.log('Integration = UNICO CHECK!')
          this.comp = UNICOCHECK;
          break;

        default:
          this.comp = Email;
          break;
      }
    }

    this.agree = this.accessConfig.registerView.agreeDefaultValue ? this.accessConfig.registerView.agreeDefaultValue : false;

    if (this.$route.name == 'NewPassword') this.changePassword = true;
    else if (this.$route.name == 'Register')
      //this.register = true;
      this.setRegister(true);
    else if (this.$route.name == 'Login') this.showLogin();

    // ORDERING INPUT FIELDS ARRAY
    this.registerFieldGroups = this.accessConfig.registerView.fieldGroups.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
    this.registerFieldGroups.map((group) => {
      group.fields.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
    });

    // CONDITIONS TO LOWER CASE
    this.registerFieldGroups.map((group) => {
      group.fields.map((field) => {
        if (field.conditional)
          field.conditional.map((item) => {
            item.condition = item.condition.map((cond) => {
              cond = cond.toLowerCase();
              // console.log('CONDITION inregister: ', cond);
              return cond;
            });
          });
      });
    });
    if (this.$route.params.preview === 'login') {
      this.setRegister(false);
    }
  },
};
</script>

<style lang="scss">
.login-register {
  position: relative;
  width: 100vw;
  height: 100dvh;
  background-color: var(--bgColor);
  background-size: cover;
  background-image: var(--background-landscape);
  background-position: center center;
  overflow-y: auto;

  @media screen and (orientation: portrait) {
    background-image: var(--background-portrait);
    background-position: top center;
  }
}

.login-register-language-switcher {
  position: absolute;
  top: 4px;
  right: 10px;
  z-index: 10;
}

.login-content-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
  min-height: calc(100dvh - var(--banner-height, 0px));
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;

  @media screen and (max-width: 950px) {
    padding: 10px 10px 40px;
    justify-content: center;
    flex-direction: column;
  }

  @include media('<=phone') {
    margin: 6px auto 40px;
  }
}

.kv-spacer {
  position: relative;
  width: 100%;
  max-width: 800px;
  max-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    float: left;
    width: 1px;
    padding-top: calc(400px / 800px * 100%);
  }

  &::after {
    content: '';
    clear: both;
    display: table;
  }

  img {
    max-width: 100%;
    padding: 0 10px;
  }
}

.outside-inside-container {
  position: relative;
  // width: 100%;
  // max-width: 400px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.fields-container {
  position: relative;
  // max-width: 400px;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--panelColor);
  -webkit-backdrop-filter: var(--backdropFilter);
  backdrop-filter: var(--backdropFilter);
  border-radius: var(--input-borderRadius);
  box-shadow: var(--boxShadow);
  border: 1px solid var(--input-panelBorderColor);
  overflow: hidden;

  @include media('<=phone') {
    width: 100%;
    min-width: 90vw;
  }
}

.opt-container {
  position: relative;
  width: 100%;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  .login-logo {
    max-width: 400px;
    max-height: 120px;
    object-fit: contain;
    object-position: center;

    width: 100%;
    @media screen and (max-width: 950px) {
    }
  }
}

.login-form {
  position: relative;
  padding: 4% 5% 2%;
  width: 100%;
  border-bottom-right-radius: var(--input-borderRadius);
  border-bottom-left-radius: var(--input-borderRadius);

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .inactive-register-text {
    position: relative;
    width: 100%;
    text-align: center;
    font-size: 1.8rem;
    color: var(--labelColor);
    margin: 10px 0;
  }
}

.login-fields-container {
  position: relative;
  width: 100%;
}

.field-wrapper {
  position: relative;
  background-color: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--input-borderRadius);
  height: 40px;
  min-width: 60%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.login-field {
  position: relative;
  padding: 0 10px;
  width: 100%;
  border: 0;
  outline: none;
  color: var(--input-text);
  background-color: transparent;
  &::placeholder {
    color: var(--input-text);
    opacity: 0.8;
  }
}

.login-button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--button-background);
  padding: 1%;
  margin: 4% 0 2% 0;
  height: 40px;
  min-width: 60%;
  width: 100%;
  border: 1px solid var(--button-outline);
  border-radius: var(--input-borderRadius) !important;
  color: var(--button-text);
  font-weight: bold;
  letter-spacing: 0.1rem;
  cursor: pointer;
  outline: none;
}

.google-login {
  margin-top: 6px;
}

.register-term-text {
  color: var(--labelColor);
  span {
    color: var(--labelColor) !important;
  }
}

.bottom-instructions {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.login-click-here p {
  color: var(--labelColor);
}
.login-forgot-password p {
  color: var(--labelColor);
}

.telephone-input {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.bottom-out-link-container {
  color: var(--labelColor);

  a {
    color: var(--labelColor);
  }
}

input[type='checkbox'] {
  cursor: pointer;
}
</style>
